class SMGAboutHeroVideo {
  constructor() {
    /** @type {HTMLVideoElement | null} */
    this.video = document.getElementById('smg-about-hero-video') || 
                 document.querySelector('.smg-about-hero__video-container video');
    
    if (!this.video) {
      console.log('Video element not found');
      return;
    }
    
    /** @type {HTMLButtonElement | null} */
    this.playBtn = document.querySelector('[data-action="play-pause"]');
    /** @type {HTMLButtonElement | null} */
    this.muteBtn = document.querySelector('[data-action="mute"]');
    
    /** @type {SVGElement | null} */
    this.playIcon = this.playBtn?.querySelector('.smg-about-hero__icon--play');
    /** @type {SVGElement | null} */
    this.pauseIcon = this.playBtn?.querySelector('.smg-about-hero__icon--pause');
    /** @type {SVGElement | null} */
    this.soundOnIcon = this.muteBtn?.querySelector('.smg-about-hero__icon--sound-on');
    /** @type {SVGElement | null} */
    this.soundOffIcon = this.muteBtn?.querySelector('.smg-about-hero__icon--sound-off');
    
    console.log('Video found:', this.video);
    this.init();
  }
  
  init() {
    if (!this.video) return;
    
    this.video.play().catch((/** @type {Error} */ err) => {
      console.log('Autoplay prevented:', err);
    });
    
    if (this.playBtn) {
      this.playBtn.addEventListener('click', () => this.togglePlay());
    }
    
    if (this.muteBtn) {
      this.muteBtn.addEventListener('click', () => this.toggleMute());
    }

    this.video.addEventListener('play', () => this.updatePlayIcon(true));
    this.video.addEventListener('pause', () => this.updatePlayIcon(false));
    
    this.updatePlayIcon(!this.video.paused);
    this.updateMuteIcon();
  }
  
  togglePlay() {
    if (!this.video) return;
    
    if (this.video.paused) {
      this.video.dataset.manualPause = 'false';
      this.video.play();
    } else {
      this.video.dataset.manualPause = 'true';
      this.video.pause();
    }
  }
  
  toggleMute() {
    if (!this.video) return;
    
    this.video.muted = !this.video.muted;
    this.updateMuteIcon();
  }
  
  /**
   * @param {boolean} isPlaying
   */
  updatePlayIcon(isPlaying) {
    if (this.playIcon && this.pauseIcon) {
      /** @type {HTMLElement} */ (this.playIcon).style.display = isPlaying ? 'none' : 'block';
      /** @type {HTMLElement} */ (this.pauseIcon).style.display = isPlaying ? 'block' : 'none';
    }
  }
  
  updateMuteIcon() {
    if (!this.video || !this.soundOnIcon || !this.soundOffIcon) return;
    
    /** @type {HTMLElement} */ (this.soundOnIcon).style.display = this.video.muted ? 'none' : 'block';
    /** @type {HTMLElement} */ (this.soundOffIcon).style.display = this.video.muted ? 'block' : 'none';
  }
}

function initAboutHeroVideo(container) {
  const root = container || document;
  const section = root.querySelector
    ? root.querySelector('.smg-about-hero') || root
    : root;
  // Destroy existing instance if any
  if (section._heroVideo) {
    section._heroVideo = null;
  }
  const instance = new SMGAboutHeroVideo();
  section._heroVideo = instance;
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initAboutHeroVideo());
} else {
  initAboutHeroVideo();
}

// Shopify Theme Editor events
document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector && e.target.querySelector('.smg-about-hero__video-container')) {
    initAboutHeroVideo(e.target);
  }
});
